module.exports = __webpack_public_path__ + "img/SIPS.a2a44ae0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SIPS.gif
// module id = SsYJ
// module chunks = 0